module.exports = __webpack_public_path__ + "static/media/logo.4bb9e0e9.svg";